<template>
  <div class="logo-slogan-component">
    <ym-img class="logo"
            :src="require('@/assets/img/default/logo.png')"
            alt="Logo"
    />
    <ym-img class="slogan"
            :src="require('@/assets/img/default/slogan.png')"
            alt="slogan"
    />
    <ym-img class="oval left"
            :src="require('@/assets/img/default/login_oval_left.png')"
            alt="ovalLeft"
    />
    <ym-img class="oval right"
            :src="require('@/assets/img/default/login_oval_right.png')"
            alt="ovalRight"
    />
  </div>
</template>

<script>
  export default {
    name: 'LogoSlogan',
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .logo {
    display: block;
    width: 360px;
    margin: 0 auto @size-large;
  }

  .slogan {
    display: block;
    width: 405px;
    margin: 0 auto;
  }

  .oval {
    position: absolute;
    &.left {
      top: 0;
      left: 0;
      width: 185px;
      height: 163px;
    }
    &.right {
      top: 248px;
      right: 0;
      width: 80px;
      height: 160px;
    }
  }
</style>
